/**
 * Keeps .drawer__body__wrapper scrollable on mobile by capping its height to
 * .drawer__body minus the Mirra banner (if visible) and the fixed .drawer__action__btn block.
 */
(function () {
  var CART_UPDATED = 'action:cart:updateCart';
  var SHOW_DRAWER = 'action:showDrawer';

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function measureAndApply() {
    var root = document.querySelector('cart-drawer-component');
    if (!root) return;

    /* drawer-type + .drawer live on the host; querySelector() does not match the host */
    var body = root.querySelector('.drawer__body');
    var wrapper = root.querySelector('.drawer__body__wrapper');
    var action = root.querySelector('.drawer__action__btn');
    if (!body || !wrapper || !action) return;

    var bodyH = body.clientHeight;
    if (bodyH < 8) return;

    var actionH = Math.ceil(action.getBoundingClientRect().height);
    if (!actionH) actionH = action.offsetHeight;
    if (!actionH) return;

    root.style.setProperty('--set-container-height', actionH + 'px');

    var banner = root.querySelector('[data-mirra-tryon-banner]');
    var bannerH = 0;
    if (banner) {
      var hidden = banner.hasAttribute('hidden');
      var visible = banner.classList.contains('is-visible');
      if (!hidden && visible) {
        bannerH = Math.ceil(banner.getBoundingClientRect().height);
      }
    }

    var maxPx = Math.max(120, bodyH - bannerH - actionH);
    wrapper.style.maxHeight = maxPx + 'px';
  }

  var debounced = debounce(function () {
    requestAnimationFrame(measureAndApply);
  }, 32);

  function scheduleRetries() {
    [0, 50, 150, 350, 600].forEach(function (ms) {
      setTimeout(function () {
        requestAnimationFrame(measureAndApply);
      }, ms);
    });
  }

  document.addEventListener(CART_UPDATED, scheduleRetries);

  document.addEventListener(SHOW_DRAWER, function (e) {
    if (e.detail && e.detail.drawerType === 'cart-drawer') {
      scheduleRetries();
    }
  });

  window.addEventListener('resize', debounced);
  window.addEventListener('orientationchange', debounced);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRetries);
  } else {
    scheduleRetries();
  }

  var ro;
  function wireResizeObserver() {
    if (!window.ResizeObserver) return;
    var root = document.querySelector('cart-drawer-component');
    if (!root) return;
    if (ro) ro.disconnect();
    ro = new ResizeObserver(debounced);
    var body = root.querySelector('.drawer__body');
    var action = root.querySelector('.drawer__action__btn');
    if (body) ro.observe(body);
    if (action) ro.observe(action);
    var banner = root.querySelector('[data-mirra-tryon-banner]');
    if (banner) ro.observe(banner);
  }

  wireResizeObserver();
  document.addEventListener(SHOW_DRAWER, function (e) {
    if (e.detail && e.detail.drawerType === 'cart-drawer') {
      setTimeout(wireResizeObserver, 0);
      wireBannerObserver();
    }
  });

  function wireBannerObserver() {
    var root = document.querySelector('cart-drawer-component');
    if (!root || !window.MutationObserver) return;
    var banner = root.querySelector('[data-mirra-tryon-banner]');
    if (!banner || banner.dataset.mirraDrawerHeightObserved) return;
    banner.dataset.mirraDrawerHeightObserved = 'true';
    new MutationObserver(debounced).observe(banner, {
      attributes: true,
      attributeFilter: ['hidden', 'class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireBannerObserver);
  } else {
    wireBannerObserver();
  }
})();

